import { cx } from "./cx";

export interface AvatarProps {
  /** Display name — used for initials and alt text. */
  name: string;
  src?: string;
  size?: "sm" | "md" | "lg";
  className?: string;
}

function initials(name: string): string {
  return name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join("");
}

/** Identity chip — lightweight, for later account surfaces (M7). */
export function Avatar({ name, src, size = "md", className }: AvatarProps) {
  return (
    <span className={cx("pz-avatar", size !== "md" && `pz-avatar--${size}`, className)}>
      {src ? (
        // eslint-disable-next-line @next/next/no-img-element -- user-content avatar, sized by tokens
        <img className="pz-avatar__img" src={src} alt={name} />
      ) : (
        <span aria-label={name}>{initials(name)}</span>
      )}
    </span>
  );
}
